<app-page>
    <app-page-header eyebrow="Gebruikersbeheer" title="Bedrijven">
        @if (!showCreate) {
            <a actions mat-flat-button routerLink="/{{Routenames.companies}}/new">
                <i class="fa-regular fa-plus"></i> Bedrijf toevoegen
            </a>
        }
    </app-page-header>

    <div class="filters">
        <app-filter-chips [(value)]="filter" [options]="filters()"></app-filter-chips>
        <mat-form-field class="search">
            <i class="fa-regular fa-magnifying-glass ui-faint" matPrefix></i>
            <input (input)="query.set($any($event.target).value)"
                   [value]="query()"
                   aria-label="Zoek op naam, Azure-team of debiteur"
                   matInput
                   placeholder="Zoek op naam, Azure-team of debiteur"
                   type="search">
        </mat-form-field>
    </div>

    <!-- TODO(design): README open point 13 — one AFAS debtor is shared by several companies and the meaning of Groundbirds / Intern is not confirmed; the list shows the data as is. -->
    <div class="list-card">
        <app-data-list columns="minmax(0,1.3fr) minmax(0,1.5fr) 130px 190px 16px" minWidth="780px">
            <div app-data-row chevron header>
                <span>Bedrijf</span>
                <span>Azure-team</span>
                <span>AFAS-debiteur</span>
                <span>Labels</span>
            </div>
            @for (company of rows(); track company.id) {
                <a app-data-row chevron dense routerLink="/{{Routenames.companies}}/{{company.id}}">
                    <span class="name">
                        @if (company.color) {
                            <span [style.background]="company.color" class="color-dot" title="Klantkleur {{ company.color }}"></span>
                        }
                        <span [title]="company.name" class="ui-strong ui-ellipsis">{{ company.name }}</span>
                    </span>
                    @if (company.azure_desc) {
                        <span [title]="company.azure_desc" class="small-cell ui-ellipsis">{{ company.azure_desc }}</span>
                    } @else {
                        <span class="small-cell ui-faint">Niet gekoppeld</span>
                    }
                    @if (company.afas_debtor_id) {
                        <span class="small-cell ui-mono">{{ company.afas_debtor_id }}</span>
                    } @else {
                        <span class="small-cell none">—</span>
                    }
                    <span class="labels">
                        @if (company.is_groundbirds) {
                            <app-status-badge [dot]="false" tone="info" variant="tag">Groundbirds</app-status-badge>
                        }
                        @if (company.is_internal) {
                            <app-status-badge [dot]="false" tone="ok" variant="tag">Intern</app-status-badge>
                        }
                    </span>
                </a>
            }
        </app-data-list>
        @if (companies() === null) {
            <app-empty-state>Aan het laden...</app-empty-state>
        } @else if (!rows().length) {
            <app-empty-state>Geen bedrijven gevonden.</app-empty-state>
        }
    </div>
</app-page>
